import styled from 'styled-components';
import DummyMap from '../../assets/images/map_dummy.png';
import { Card, Progress } from 'antd';
export const GeoreferenceWrapper = styled.div `
  position: absolute;
  z-index: 0;
  left: 0px;
  overflow:hidden;
  top: 0px;
  width: 100%;
  height: 100%;
  touch-action: none;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  outline: none;
  cursor: default;
`;
export const GeoreferenceMap = styled.div `
  // background-image: url(${DummyMap});
  position: absolute;
  z-index: 0;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
`;
export const MapPanel = styled(Card) `
  position: absolute;
  left: 12px;
  z-index: 10;
  border-radius: 15px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.07), 0 15px 35px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  background-color: hsla(0, 0%, 100%, 1);
  min-width: 320px;
  top: unset;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  width: 30%;
  min-height: 120px;
  box-sizing: content-box;
  --bc-card-header-height: 50px;
  .bc-card-head {
    display: none;
    // --bc-border-radius-lg: ${({ theme }) => theme.borders.radius.sm};
    // position: relative;
    // overflow: hidden;
    // padding-top: 8px;
    // background-color: ${({ theme }) => theme.colors.gray100};
  }
  .bc-card-body {
    display: flex;
    flex: 1;
    flex-direction: column;

    --bc-padding-lg: 0;
  }
`;
export const MapPanelHeader = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
`;
export const BuildingProgress = styled(Progress) `
  display: flex;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  --bc-line-height: 0;
  --bc-progress-line-border-radius: 0 !important;

  .bc-progress-steps-outer {
    flex: 1 1 auto;
  }
  .bc-progress-bg-outer {
    height: 4px !important;
    flex: 1;
  }
  .bc-progress-text {
    display: none;
  }
`;
export const MapPanelBody = styled.div `
  display: flex;
  flex-direction: row;
  flex: 0 0 auto;
  width: 100%;
  /* padding: 12px 16px; */

  input {
    background-color: #f1f1f4;
    border-color: #f1f1f4;
    color: #4b5675;
  }
`;
export const MapPanelLeft = styled.div `
  width: 100%;
  padding: 12px 16px 12px;
  /* background-color: rebeccapurple; */
  border-right: 1px solid ${({ theme }) => theme.colors.gray300};
`;
export const MapPanelRight = styled.div `
  width: 100%;
  padding: 12px 16px 12px;
  /* background-color: aqua; */
`;
export const PropertiesPanel = styled.div `
  ${(props) => (props.border ? `border: 1px solid #f0f0f0; padding: 6px 12px 3px 12px;` : `border: none;`)}
  margin-top: 12px;
  border-radius: 8px;
`;
export const PropertiesPanelHeader = styled.div `
  cursor: pointer;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 0.5rem;
  label {
    line-height: 18px;
    font-size: 12px;
    font-weight: 600;
    flex-grow: 1;
  }
`;
export const PropertiesPanelBody = styled.div `
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: 'input1 input2';
  column-gap: 0.5rem;
  align-items: center;
`;
export const MapPanelToolBar = styled.div `
  top: 264.443px;
  left: 1038.18px;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
  z-index: 10;
  border: 2px solid rgba(0, 0, 0, 0);
  cursor: default;
  box-sizing: content-box;
  border-radius: 10px;
  transition: box-shadow 0.3s ease-in-out, border 0.3s ease-in-out;
`;
export const MapPanelToolBarInner = styled.div `
  box-shadow: 0px 6px 20px rgba(25, 25, 26, 0.06), 0px 2px 12px rgba(25, 25, 26, 0.04);
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 42px;
  background-color: #ffffff;
  padding: 5px;
  border-radius: 10px;
  gap: 4px;
  position: relative;
`;
